/**
 * Database Navigation Component
 * 
 * Sticky top navigation for switching between database categories.
 * Shows current database with premium wine/gold styling.
 */

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
    Heart, Activity, Zap, MapPin, Sparkles, Users, Package,
    User, Move, Fingerprint, Link2, Gamepad2
} from 'lucide-react';

// Grouped tabs with visual separators between logical sections
export const DATABASE_TAB_GROUPS = [
    // Identity & Dynamics
    {
        label: 'Kink & BDSM',
        tabs: [
            { path: '/db/kinks', label: 'Kinks', icon: Heart, matchPaths: ['/browse', '/db/kinks'] },
            { path: '/db/archetypes', label: 'Archetypes', icon: Users, matchPaths: ['/archetypes', '/db/archetypes'] },
            { path: '/db/dynamics', label: 'Dynamics', icon: Link2, matchPaths: ['/db/dynamics'] },
        ]
    },
    // The Physical & Psychological Experience
    {
        label: 'Sex & Desire',
        tabs: [
            { path: '/db/actions', label: 'Sex Acts', icon: Zap, matchPaths: ['/actions', '/db/actions'] },
            { path: '/db/positions', label: 'Positions', icon: Move, matchPaths: ['/db/positions'] },
            { path: '/db/bodyParts', label: 'Body Parts', icon: Fingerprint, matchPaths: ['/db/bodyParts'] },
            { path: '/db/mechanics', label: 'Arousal Sources', icon: Activity, matchPaths: ['/mechanics', '/db/mechanics'] },
            { path: '/db/effects', label: 'Arousal Effects', icon: Sparkles, matchPaths: ['/effects', '/db/effects'] },
        ]
    },
    // The Setting
    {
        label: 'Scenes & Play',
        tabs: [
            { path: '/db/scenarios', label: 'Scenarios', icon: MapPin, matchPaths: ['/scenarios', '/db/scenarios'] },
            { path: '/db/activities', label: 'Activities', icon: Gamepad2, matchPaths: ['/db/activities'] },
            { path: '/db/gear', label: 'Gear', icon: Package, matchPaths: ['/gear', '/db/gear'] },
        ]
    },
    // The People
    {
        label: 'Characters',
        tabs: [
            { path: '/db/characters', label: 'Characters', icon: User, matchPaths: ['/db/characters'] },
        ]
    },
];

function DatabaseNav() {
    const location = useLocation();
    const currentPath = location.pathname;

    return (
        <div className="bg-charcoal-950/90 backdrop-blur-sm border-b border-wine-900/30 sticky top-0 z-40">
            <div className="max-w-[1800px] mx-auto px-4 md:px-6">
                <nav className="flex items-center gap-0.5 py-1.5 overflow-x-auto scrollbar-thin scrollbar-thumb-wine-800/50 scrollbar-track-transparent md:overflow-visible">
                    {DATABASE_TAB_GROUPS.map((group, groupIdx) => (
                        <React.Fragment key={groupIdx}>
                            {/* Separator between groups */}
                            {groupIdx > 0 && (
                                <div className="w-px h-6 bg-wine-800/30 mx-2 shrink-0 hidden sm:block" />
                            )}
                            {group.tabs.map(({ path, label, icon: Icon, matchPaths }) => {
                                const isActive = matchPaths?.some(p => currentPath === p || currentPath.startsWith(p + '/')) ||
                                    (path === '/browse' && currentPath === '/');

                                return (
                                    <Link
                                        key={path}
                                        to={path}
                                        className={`relative flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium transition-all whitespace-nowrap shrink-0 ${isActive
                                            ? 'text-[#C4A35A]'
                                            : 'text-cream/45 hover:text-cream/80'
                                            }`}
                                    >
                                        <Icon className={`w-4 h-4 ${isActive ? 'text-[#C4A35A]' : ''}`} />
                                        <span className="hidden sm:inline">{label}</span>
                                        <span className="sm:hidden">{label.split(' ')[0]}</span>
                                        {/* Active underline accent */}
                                        {isActive && (
                                            <span className="absolute bottom-0 left-2 right-2 h-[2px] bg-gradient-to-r from-[#C4A35A]/80 via-[#C4A35A] to-[#C4A35A]/80" />
                                        )}
                                    </Link>
                                );
                            })}
                        </React.Fragment>
                    ))}
                </nav>
            </div>
        </div>
    );
}

export default DatabaseNav;

